export const ReduxInit											= '@@redux/INIT';

export const ResetState											= '@RUUI:RESET-STATE';
export const UpdateThemeConfigs							= '@RUUI:UPDATE-THEME-CONFIGS';
export const UpdateDimensionInfo						= '@RUUI:UPDATE-DIMENSIONS-INFO';
export const UpdateNetInfo									= '@RUUI:UPDATE-NET-INFO';
export const ToggleSelect										= '@RUUI:TOGGLE-SELECT';
export const ToggleModal										= '@RUUI:TOGGLE-MODAL';
export const ToggleDropdown									= '@RUUI-TOGGLE-DROPDOWN';
export const ToggleLoading									= '@RUUI:TOGGLE-LOADING';
export const RouterPush											= '@ROUTER:PUSH';
export const RouterGoTo											= '@ROUTER:GOTO';
export const RouterReplace									= '@ROUTER:REPLACE';
export const RouterPop											= '@ROUTER:POP';
export const RouterReset										= '@ROUTER:RESET';
export const InsertSnackBar									= '@RUUI-INSERT-SNACK-BAR';
export const StartDestroySnackBar						= '@RUUI-START-DESTROY-SNACK-BAR';
export const DestroySnackBar								= '@RUUI-DESTROY-SNACK-BAR';
